/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var textarea_component_1 = require("./textarea/textarea.component");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var textarea_suffix_component_1 = require("./textarea/textarea-suffix.component");
var shared_module_1 = require("./shared.module");
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the TextArea component.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the TextArea module
 * import { TextAreaModule } from '@progress/kendo-angular-inputs';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, TextAreaModule], // import TextArea module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
var TextAreaModule = /** @class */ (function () {
    function TextAreaModule() {
    }
    TextAreaModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [
                textarea_component_1.TextAreaComponent,
                textarea_suffix_component_1.TextAreaSuffixComponent
            ],
            exports: [
                textarea_component_1.TextAreaComponent,
                kendo_angular_common_1.EventsModule,
                textarea_suffix_component_1.TextAreaSuffixComponent,
                shared_module_1.SHARED_DIRECTIVES
            ],
            imports: [common_1.CommonModule, kendo_angular_common_1.EventsModule, shared_module_1.SharedModule]
        })
    ], TextAreaModule);
    return TextAreaModule;
}());
exports.TextAreaModule = TextAreaModule;
